import styled from 'styled-components';
import BgLogin from 'assets/images/bg-login.jpg';

export const Content = styled.div`
  width: 100%;
  min-height: 100vh;
  background: ${() => `url(${BgLogin})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--blue-senac);
    opacity: 0.65;
    z-index: 1;
  }

  .container {
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    z-index: 2;
    position: relative;

    > form {
      width: 400px;
      max-width: 100%;
    }
  }
`;

export const Logo = styled.img`
  width: 100%;
  height: 80px;
  object-fit: contain;
  object-position: center;
  margin: 16px 0;
`;

export const Title = styled.p`
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  margin: 8px 0;
`;
